/**
 * Parses a JSON query parameter, accepting both raw and URL-encoded values.
 * Returns the provided fallback when the parameter is empty or malformed.
 * @param {string} value - Query parameter value.
 * @param {*} [fallback={}] - Value returned when parsing fails.
 * @returns {*} Parsed JSON value or fallback.
 */
export default (value, fallback = {}) => {
  if (!value) return fallback;

  try {
    return JSON.parse(value);
  } catch {
    try {
      return JSON.parse(decodeURIComponent(value));
    } catch {
      return fallback;
    }
  }
};
